exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1 {\n  background: #fcfdff;\n  background: linear-gradient(to bottom, red, blue);\n}\nh1 span {\n  color: blue;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/davidlagace/Sites/david-lagace-website/src/app/app.component.less
// module id = ../../../../../src/app/app.component.less
// module chunks = main